import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';
import { ContratosService } from 'src/app/service/contratos.service';

@Component({
  selector: 'app-dialog-contrato',
  templateUrl: './dialog-contrato.component.html',
  styleUrls: ['./dialog-contrato.component.css']
})
export class DialogContratoComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DialogContratoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogContratoComponent, fb: FormBuilder,
    private contratoService: ContratosService, private alertService: AlertService, private formBuilder: FormBuilder,) {
    this.form = this.formBuilder.group({
      data: new FormControl('', [Validators.required]),
      dataVencimento: new FormControl('')
    })
  }

  form!: FormGroup;
  dado:any;

  ngOnInit(): void {
    this.dado = this.data
  }

  cancel() {
    this.dialogRef.close();
  }

  confirmar(){
    this.form.value.data = this.form.value.data.toISOString().replace(/T/, " ").replace(/\..+/, "")
    if( this.form.value.dataVencimento != ''){
      this.form.value.dataVencimento = this.form.value.dataVencimento.toISOString().replace(/T/, " ").replace(/\..+/, "")
    }
    this.dado.data = this.form.value.data;
    this.dado.proxVencimento = this.form.value.dataVencimento;
    this.contratoService.cancelaOuRenova(this.dado).subscribe((resp) => {
      this.alertService.success();
      this.dialogRef.close();
    }, error => {
      this.alertService.error(error);
      this.dialogRef.close();
    }
    )
  }
}
